export default __webpack_public_path__ + "static/media/hajC.75689148.jpg";